import { querySelectorAllDeep } from 'query-selector-shadow-dom';
import { DebugService } from './debug.service';

class _FormValidationService {
  debug: DebugService;
  constructor() {
    this.debug = new DebugService('FormValidationService');
  }

  async validateAllFields(form: HTMLElement, blur = true) {
    this.debug.log('validateAllFields called with', form);
    const inputs = querySelectorAllDeep('input, select, textarea', form);
    let firstInvalid!: HTMLInputElement;
    let focused = false;
    await inputs.forEach(async (input: HTMLInputElement) => {
      const valid = await input.checkValidity();
      if (!valid) {
        if (!firstInvalid) {
          firstInvalid = input;
        }
        if (blur) {
          input.focus();
        }
        focused = true;
      }
    });
    if (firstInvalid && blur) {
      firstInvalid.blur();
      firstInvalid.focus();
    }
    return !focused;
  }
}

export const FormValidationService = new _FormValidationService();
